export { default } from "./Small";
